export default "__VITE_ASSET__ef8caf3f__"